










import { Component, Vue } from "vue-property-decorator";
import TopHeader from "@/components/TopHeader.vue";
import FooterComponent from "@/components/FooterComponent.vue";

@Component({
  components: {
    "top-header": TopHeader,
    "footer-component": FooterComponent
  },
  async mounted() {
    this.$store.dispatch("loadCats");
  }
})
export default class Home extends Vue {}
